module.exports = __webpack_public_path__ + "img/account.06d8cef7.png";